import type { DetailedHTMLProps, FC, HTMLAttributes } from 'react';

import { Link } from 'react-router-dom';
import type { SvpAssetAdditional } from '@vgtv/api-client/lib/svp_asset';

import { deeplinksSupported } from '../../utils/device';
import { getPath, routeNames } from '../../shared/helpers/routes';

interface AssetLinkProps
  extends Omit<
    DetailedHTMLProps<HTMLAttributes<HTMLAnchorElement>, HTMLAnchorElement>,
    'ref'
  > {
  asset: SvpAssetAdditional;
  time?: number;
  replacePath?: boolean;
}

const AssetLink: FC<AssetLinkProps> = ({
  asset,
  time,
  replacePath,
  ...props
}) => {
  const targetUrl = getPath(routeNames.asset, {
    asset,
    time,
  });

  if (deeplinksSupported) {
    // eslint-disable-next-line jsx-a11y/anchor-has-content
    return <a {...props} href={targetUrl} />;
  }

  return <Link {...props} replace={replacePath} to={targetUrl} />;
};

export { AssetLink };
